module.exports = __webpack_public_path__ + "media/images/notice-2eb49073fc508bd28daf68e49057ca8d.svg";